import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import DropdownActivator from 'scaleflow/utils/dropdown-activate';
import { assignTeamsToInitiative } from 'scaleflow/utils/assign-teams-to-initiative';

export default class InitiativesTableTeamSelectorComponent extends DropdownActivator {
  @service('organisation') orgService;
  @service store;

  @tracked teamFormIsVisible = false;

  selectedInitiative = null;

  get initiative() {
    return this.args.initiative;
  }

  @action
  toggleTeamForm(initiative, val) {
    if (initiative) this.selectedInitiative = initiative;
    else this.selectedInitiative = null;
    if (val !== undefined) this.teamFormIsVisible = val;
    else this.teamFormIsVisible = !this.teamFormIsVisible;
  }

  @action
  async onTeamAdded(team) {
    const initiative = this.selectedInitiative;
    const teams = (initiative.teams?.content ?? []).map((item) => item.id);
    teams.push(team.id);
    await this.handleTeamClick(initiative, teams);
  }

  @action
  async handleTeamClick(initiative, team_ids) {
    await assignTeamsToInitiative(
      this.store,
      this.orgService,
      initiative,
      team_ids,
    );
  }

  willDestroy() {
    this.selectedInitiative = null;
    this.teamFormIsVisible = false;
    super.willDestroy(...arguments);
  }
}
